import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Card, Col, Row, Table, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getToken } from '../services/authorize'
import axiosInstance from "../services/axiosInterceptor"
import Swal from "sweetalert2";
import { getUserId } from "../services/authorize";
import { useLoading } from '../contexts/LoadingContext';
import { getDayNameTHByIndex, groupSubjectData, formatTimeShort, getSemesterOrder } from "../utils/teachingUtils";

// รายละเอียดคาบสอน ใช้ทั้งในตารางและการ์ด
const TimesDisplay = ({ times }) => (
  times && times.length > 0
    ? times.map((t, i) => (
        <div key={i}>
          {t.period_order
            ? <>{`วัน${getDayNameTHByIndex(t.teach_day)} คาบ ${t.period_order}`}<br />{`(${formatTimeShort(t.period_begin)} - ${formatTimeShort(t.period_end)})`}</>
            : "ยังไม่ระบุ"}
        </div>
      ))
    : "-"
)

// การ์ดรายวิชา 1 รายการ สำหรับมุมมองมือถือ
const SubjectCard = ({ item }) => (
  <div className="border rounded p-3">
    <div className="fw-semibold">{item.sub_subid} {item.sub_subname}</div>
    <div className="fs-xs text-muted">ชั้น {item.tb_class_c_id}/{item.r_no} · ภาคเรียนที่ {item.sub_semester}</div>
    <div className="mt-2 pt-2 border-top fs-sm">
      <div><span className="text-muted">คาบ:</span> <TimesDisplay times={item.times} /></div>
      <div><span className="text-muted">อาจารย์ที่ปรึกษา:</span> {item.advisor_name}</div>
    </div>
    <div className="mt-2 pt-2 border-top d-flex flex-column gap-2">
      <Dropdown>
        <Dropdown.Toggle variant="outline-danger" size="sm" className="w-100" id={`dropdown-care-card-${item.teach_id}`}>
          ดูแลนักเรียน
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {/* ปิดชั่วคราว: ระบบการประเมินพฤติกรรมการเรียน (รอบ 2 สัปดาห์)
          <Dropdown.Item as={Link} to={`/teaching/behavior-assessment/${item.teach_id}`}>
            <i className="ri-survey-line me-1"></i>ประเมินพฤติกรรมการเรียน (รอบ 2 สัปดาห์)
          </Dropdown.Item>
          */}
          <Dropdown.Item as={Link} to={`/teaching/subject-care/${item.teach_id}`}>
            <i className="ri-flag-2-line me-1"></i>การแจ้งดูแล / บันทึกการช่วยเหลือ
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <Link to={`/students/student-in-class/${item.r_id}/${item.tb_class_c_id}/${item.r_no}`}
        state={{ subId: item.sub_subid, subName: item.sub_subname }}
        className="btn btn-outline-primary btn-sm w-100">
        <i className="ri-file-list-line me-1" />แสดงรายชื่อนักเรียน
      </Link>
    </div>
  </div>
)

export default function SubjectClass() {
  const { setLoading } = useLoading();
  ///// Skin Switch /////
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');
      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }

    // Toggle dark mode for all tables
    const tables = document.getElementsByTagName('table');
    for (const table of tables) {
      const theads = table.querySelectorAll('thead'); // หาทุก thead ภายใน table
      if (skin === 'dark') {
        for (const thead of theads) {
          thead.classList.remove('table-secondary');
          thead.classList.add('table-primary');
        }
        table.classList.add('table-dark');
      } else {
        table.classList.remove('table-dark');
        for (const thead of theads) {
          thead.classList.remove('table-primary');
          thead.classList.add('table-secondary');
        }
      }
    }
  }

  switchSkin(skin);

  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  const [data, setData] = useState({})
  const [yearId, setYearId] = useState(() => {
    return localStorage.getItem('yearId') || null;
  })
  const [selectedYear, setSelectedYear] = useState("");
  const [yearList, setYearList] = useState([]);
  const [view, setView] = useState(() =>
    (typeof window !== 'undefined' && window.innerWidth < 768) ? 'card' : 'table')

  useEffect(() => {
    setLoading(true);
    // get yearId from lastest year in database
    axiosInstance.get(`${process.env.REACT_APP_API}/getStudyYear`, {
      headers: {
        authorization: `Bearer ${getToken()}`
      }
    })
      .then(res => {
        const list = res.data;
        setYearList(list);

        // ถ้า yearId ยังไม่มีใน localStorage ให้ใช้ปีล่าสุด
        let initialYearId = localStorage.getItem('yearId');
        if (!initialYearId && list.length > 0) {
          initialYearId = list[0].year_id;
          localStorage.setItem('yearId', initialYearId);
        }
        setYearId(initialYearId);
        const selected = list.find(y => String(y.year_id) === String(initialYearId))
        setSelectedYear(selected ? `ปีการศึกษา ${selected.year_year}` : "")
      })
      .catch(err => {
        console.log("Error loading years:", err);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [setLoading])

  useEffect(() => {
    setLoading(true);
    if (yearId === null) return; // don't run if yearId isn't loaded yet
    
    axiosInstance.get(`${process.env.REACT_APP_API}/getSubjectTeaching/${getUserId()}/${yearId}`,
    {
      headers: {
          authorization: `Bearer ${getToken()}`
      }
    })
      .then(response => {
        setData(groupSubjectData(response.data))
        // setIsLoading(false)
        // console.log(response.data)
      })
      .catch(err => {
        console.log(err.response.data.message)
        Swal.fire({
          title: err.response.data.title || err.response.statusText,
          text: err.response.data.message || err.message,
          icon: "error"
        })
        setData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [yearId, setLoading])

  // Function to handle dropdown change
  const handleSelectYear = (id) => {
    const selected = yearList.find(y => y.year_id === id);
    if (selected) {
      setYearId(id);
      setSelectedYear(`ปีการศึกษา ${selected.year_year}`);
      localStorage.setItem('yearId', id); // <-- เก็บลง LocalStorage
    }
  }

  // ถ้าตอนนี้อยู่เทอม 2 ให้แสดงภาคเรียนที่ 2 ก่อน
  const semesterOrder = getSemesterOrder();

  // การ์ดรายวิชาของภาคเรียนหนึ่ง ๆ (มุมมองการ์ด)
  const subjectCardSection = (semester) => (
    <>
      <h6 className="text-center mb-3">ภาคเรียนที่ {semester}</h6>
      <Row className="g-3 mb-4">
        {data && data.length > 0 && data.some(d => d.sub_semester === semester) ? (
          data.filter(d => d.sub_semester === semester).map(item => (
            <Col key={item.teach_id} xs={12} md={6} xl={4}>
              <SubjectCard item={item} />
            </Col>
          ))
        ) : (
          <Col xs={12}><div className="text-center text-muted py-3">ไม่พบข้อมูล</div></Col>
        )}
      </Row>
    </>
  );

  // ส่วนตาราง (หัวตาราง + แถวข้อมูล) ของภาคเรียนหนึ่ง ๆ (มุมมองตาราง)
  const subjectTableSection = (semester) => (
    <>
      <thead>
        <tr className="text-center">
          <th scope="row" colSpan={7}>ภาคเรียนที่ {semester}</th>
        </tr>
      </thead>
      <thead>
        <tr>
          <th scope="col" className="text-center" style={{ width: "80px" }}>รหัสวิชา</th>
          <th scope="col" className="text-center">ชื่อวิชา</th>
          <th scope="col" className="text-center" style={{ width: "70px" }}>ชั้น</th>
          <th scope="col" className="text-center" style={{ width: "150px" }}>คาบ</th>
          <th scope="col" className="text-center" style={{ width: "80px" }}>ภาคเรียนที่</th>
          <th scope="col" className="text-center">อาจารย์ที่ปรึกษา</th>
          <th scope="col" className="text-center" style={{ width: "280px" }}></th>
        </tr>
      </thead>
      <tbody>
        {data && data.length > 0 && data.some(d => d.sub_semester === semester) ? (
          data
            .filter(d => d.sub_semester === semester)
            .map((item) => (
              <tr key={item.teach_id}>
                <th scope="row" className="text-center">{item.sub_subid}</th>
                <td className="text-center">{item.sub_subname}</td>
                <td className="text-center">{item.tb_class_c_id + "/" + item.r_no}</td>
                <td className="text-center">
                  <TimesDisplay times={item.times} />
                </td>
                <td className="text-center">{item.sub_semester}</td>
                <td className="text-center">{item.advisor_name}</td>
                <td className="text-center">
                  <div className="d-inline-flex align-items-center gap-2">
                    <Dropdown>
                      <Dropdown.Toggle variant="outline-danger" size="sm" id={`dropdown-care-${item.teach_id}`}>
                        ดูแลนักเรียน
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {/* ปิดชั่วคราว: ระบบการประเมินพฤติกรรมการเรียน (รอบ 2 สัปดาห์)
                        <Dropdown.Item as={Link} to={`/teaching/behavior-assessment/${item.teach_id}`}>
                          <i className="ri-survey-line me-1"></i>ประเมินพฤติกรรมการเรียน (รอบ 2 สัปดาห์)
                        </Dropdown.Item>
                        */}
                        <Dropdown.Item as={Link} to={`/teaching/subject-care/${item.teach_id}`}>
                          <i className="ri-flag-2-line me-1"></i>การแจ้งดูแล / บันทึกการช่วยเหลือ
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <Link to={`/students/student-in-class/${item.r_id}/${item.tb_class_c_id}/${item.r_no}`} state={{ subId: item.sub_subid, subName: item.sub_subname }}><i className="ri-file-list-line"> แสดงรายชื่อนักเรียน</i></Link>
                  </div>
                </td>
              </tr>
            ))
        ) : (
          <tr>
            <td colSpan={7} className="text-center">ไม่พบข้อมูล</td>
          </tr>
        )}
      </tbody>
    </>
  );

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link to="#">ข้อมูลการสอน</Link></li>
              <li className="breadcrumb-item active" aria-current="page">วิชา / ห้องที่สอน</li>
            </ol>
            <h4 className="main-title mb-0">วิชา / ห้องที่สอน</h4>
          </div>
          <div className="d-flex align-items-center gap-2 mt-3 mt-md-0">
            <Dropdown>
              <Dropdown.Toggle variant="primary" id="dropdown-basic">
                {selectedYear || "เลือกปีการศึกษา"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
              {yearList.map(item => (
                <Dropdown.Item key={item.year_id} onClick={() => handleSelectYear(item.year_id)}>
                  ปีการศึกษา {item.year_year}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <Row className="g-12 mb-4">
          <Col xl="12">
            <Card className="card-one">
              <Card.Header className="d-flex align-items-center justify-content-between gap-2">
                <Card.Title as="h6" className="mb-0">{selectedYear}</Card.Title>
                <div className="btn-group btn-group-sm" role="group" aria-label="สลับมุมมอง">
                  <button type="button" className={`btn btn${view === 'table' ? '' : '-outline'}-primary`}
                    onClick={() => setView('table')} title="มุมมองตาราง">
                    <i className="ri-table-line" />
                  </button>
                  <button type="button" className={`btn btn${view === 'card' ? '' : '-outline'}-primary`}
                    onClick={() => setView('card')} title="มุมมองการ์ด">
                    <i className="ri-layout-grid-line" />
                  </button>
                </div>
              </Card.Header>
              <Card.Body className="p-3">
                {view === 'card' ? (
                  <>
                    {semesterOrder.map((sem) => (
                      <React.Fragment key={sem}>{subjectCardSection(sem)}</React.Fragment>
                    ))}
                  </>
                ) : (
                <Table responsive hover className="mb-0">
                  {semesterOrder.map((sem) => (
                    <React.Fragment key={sem}>{subjectTableSection(sem)}</React.Fragment>
                  ))}
                </Table>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Footer />
      </div>
    </React.Fragment>
  )
}